module.exports = __webpack_public_path__ + "static/beethoven-d88d004a815b0993bb12c1a5754c771e.png";